import Link from '@components/common/Link/Link'
import SublimeMedia from '@components/common/SublimeMedia/SublimeMedia'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Media from '@components/ui/Media/Media'

import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import cn from 'clsx'
import { FC } from 'react'
import { UmbracoLink } from 'types/umbracoLink'
import styles from './BlogPost.module.scss'
export type BlogPostProps = {
  image?: MediaWithCropsFragment
  teaser?: string
  title?: string
  bodyText?: string
  linkTo?: UmbracoLink
  itemWidth?: number
  disableBodyText?: boolean
  sliderItem?: boolean
  priority?: boolean
  categories?: string[]
}

const BlogPost: FC<BlogPostProps> = ({
  teaser,
  title,
  bodyText,
  image,
  linkTo,
  itemWidth,
  disableBodyText = false,
  sliderItem,
  priority,
}) => {
  return linkTo ? (
    <Link
      link={linkTo}
      className={styles.item}
      style={{
        width: itemWidth && `${100 * itemWidth}%`,
      }}
    >
      <div className={cn(styles.container, 'select-none')}>
        {image && (
          <div className={styles.imageContainer}>
            <div className={styles.imageAspectRatio}>
              <div className={styles.image}>
                <Media
                  mediaWithCrops={image}
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  mediaClassName={styles.image}
                  priority={priority}
                  disableShopTheLook
                />
              </div>
            </div>
          </div>
        )}

        {/* <p className={`${styles.teaser} teaser`}>{teaser}</p> */}
        <TrustedHtml className={styles.title} html={title} />

        {!disableBodyText && (
          <>
            <TrustedHtml className={styles.bodyText} html={bodyText} />
          </>
        )}
      </div>
    </Link>
  ) : (
    <div
      className={styles.item}
      style={{
        width: itemWidth && `${100 * itemWidth}%`,
        padding: sliderItem ? '0px' : '2rem',
      }}
    >
      <div className={cn(styles.container, 'select-none')}>
        {image && (
          <div className={styles.imageContainer}>
            <div className={styles.imageAspectRatio}>
              <div className={styles.image}>
                <SublimeMedia
                  hideCaption
                  mediaPicker={{
                    ...image,
                    media: {
                      ...image.media,
                      // @ts-ignore
                      shopTheLookJson: undefined,
                    },
                  }}
                  objectFit="cover"
                  layout="fill"
                  hoverEffect
                />
              </div>
            </div>
          </div>
        )}

        {/* <p className={`${styles.teaser} teaser`}>{teaser}</p> */}
        <TrustedHtml className={styles.title} html={title} />

        {!disableBodyText && (
          <>
            <TrustedHtml className={styles.bodyText} html={bodyText} />
          </>
        )}
      </div>
    </div>
  )
}

export default BlogPost
